import { render } from "./SuperAdminTenants.vue?vue&type=template&id=8b811516&scoped=true"
import script from "./SuperAdminTenants.vue?vue&type=script&lang=js"
export * from "./SuperAdminTenants.vue?vue&type=script&lang=js"

import "./SuperAdminTenants.vue?vue&type=style&index=0&id=8b811516&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b811516"]])

export default __exports__